export const messagelistMenuRouter = [{
  path: 'message/list',
  icon: ' iconfont iconlingdang',
  name: 'messageList',
  title: '消息配置',
  component: () => import('@/views/gip/message/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/message/messagelist.js